import {
  ITransaction,
  ITransactionStatistics,
  IFaq,
  IBaselineQuestion,
  IBaselineResult,
} from './dashboard.type';
import {
  IStatsPercategory,
  ITrackEntrepreneurship,
  ITrackInternship,
  IPreRequisiteSkill,
} from './dashboard.type';
export interface ITransactionsHistoryResponseType {
  coins: ITransaction[];
  history: ITransactionStatistics;
  page?: number;
}

export type IFaqsResponseType = IFaq[];

export interface ISkillsProgressResponseType {
  statsPerCategories: IStatsPercategory[];
  averageCompletion: number;
  averageGrade: number;
  timeInMinutes: number;
  totalModules: number;
  completedModules: number;
}

export interface ITracksProgressResponseType {
  prerequisiteSkills: IPreRequisiteSkill;
  internshipTrack: ITrackInternship;
  entrepreneurshipTrack: ITrackEntrepreneurship;
}

export interface IBaselineQuestionsResponseType {
  assessment: IBaselineQuestion[];
}

export interface IBaselineAverageItem {
  attempt: number;
  averages: IBaselineSkillAverages;
}

export interface IStudentBaselineGlobalResultItem {
  [key: string]: number;
}
export interface IStudentBaselineGlobalResult {
  [EPillarType.ACTIVE_CITIZENSHIP]: IStudentBaselineGlobalResultItem;
  [EPillarType.CAREER_READINESS]: IStudentBaselineGlobalResultItem;
  [EPillarType.COMMUNICATION]: IStudentBaselineGlobalResultItem;
  [EPillarType.LEARNING]: IStudentBaselineGlobalResultItem;
  [EPillarType.PERSONAL_DEVELOPMENT]: IStudentBaselineGlobalResultItem;
}
export interface IBaselineResultsResponseType {
  results: {
    averages: IBaselineAverageItem[];
    attempts: IBaselineResult[];
    globals: {
      averages: IBaselineSkillAverages;
      results: IStudentBaselineGlobalResult;
    };
  };
}

export enum EPillarType {
  ACTIVE_CITIZENSHIP = 'activeCitizenship',
  CAREER_READINESS = 'careerReadiness',
  COMMUNICATION = 'communication',
  LEARNING = 'learning',
  PERSONAL_DEVELOPMENT = 'personalDevelopment',
}
export interface IBaselineSkillAverages {
  [EPillarType.ACTIVE_CITIZENSHIP]: number;
  [EPillarType.CAREER_READINESS]: number;
  [EPillarType.COMMUNICATION]: number;
  [EPillarType.LEARNING]: number;
  [EPillarType.PERSONAL_DEVELOPMENT]: number;
}
export interface IStudentBaselineResultResponse {
  globalAverage: IBaselineSkillAverages;
  studentRank: IBaselineSkillAverages;
  studentsResult: {
    averages: IBaselineAverageItem[];
    attempts: IBaselineResult[];
  };
}
export interface ISpentTimeResponseType {
  hoursLoggedThisWeek: number;
  hoursLoggedLastWeek: number;
  percentageChange: number;
  percentageOfHoursLogged: number;
}

export interface IRankComparisonResponseType {
  globalRank: number;
  totalStudents: number;
  topPercentage: number;
  message: string;
}
